import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponseHasSchema } from '@/shared/api/validation'
import { z } from 'zod'
import { invoiceSchema } from '@/features/invoices/schemas'

const client = createAssetManagementClient()

export const fetchInvoiceTemplate = (assetCode: string) => validateResponseHasSchema(
  client.sendGet(`assets/${assetCode}/billings/invoices/dummies`),
  z.object({ data: invoiceSchema })
).then(
  r => r.data
)

